import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import Card from '../../../components/Card/Card';
import Text from '../../../components/Text/Text';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';
const infoDateClassName = 'mr-[10px]';

const ArticlesInformation = () => {
  const {
    articlesDetails: {
      article_post_date: postDate,
      article_last_edite: editDate
    } = {}
  } = useSelector((state) => ({
    articlesDetails: state?.getArticlesDetails.data,
  }), shallowEqual);

  return (
    <Card
      headerTitle="Info"
      showHeader
      styleBodyContainer={cardBodyClassName}
      styleContainer={cardContainerClassName}
      headerBordered={false}
    >
      <div className="flex flex-row">
        <Text text="Post at:" muted styleContainer={infoDateClassName} />
        <Text text={postDate || 'Nan'} bold />
      </div>
      <div className="flex flex-row">
        <Text text="Last edit at:" muted styleContainer={infoDateClassName} />
        <Text text={editDate || ''} bold />
      </div>
    </Card>
  );
};

export default ArticlesInformation;
